export default "__VITE_ASSET__DRACArIV__"